import { ButtonLink } from "@/components/ui/FormControls";
import { Link, NavLink } from "react-router";
import { Wordmark } from "@/components/brand/Brand";
import { useAuth } from "@/store/auth";

/**
 * 약관,개인정보처리방침처럼 로그인 없이 보는 문서의 상단 막대.
 * AppShell 은 사용자를 전제하므로 쓰지 않는다. 로그인돼 있으면 시나리오로 돌아가는 길을 낸다.
 */
export function PublicBar() {
  const { user } = useAuth();
  const link = ({ isActive }: { isActive: boolean }) => `rounded-control px-control-inset py-inline text-label font-semibold transition-colors ${isActive ? "bg-accent text-on-accent" : "text-ink hover:bg-surface-sunken hover:text-accent"}`;
  return (
    <header className="chrome-bar sticky top-0 z-nav">
      <div className="mx-auto flex w-full max-w-doc items-center gap-content px-section py-item">
        <Link to={user ? "/app" : "/login"} className="inline-flex" aria-label="홈으로">
          <Wordmark />
        </Link>
        <nav className="ml-item hidden items-center gap-label sm:flex" aria-label="문서">
          <NavLink to="/terms" className={link}>이용약관</NavLink>
          <NavLink to="/privacy" className={link}>개인정보처리방침</NavLink>
        </nav>
        <div className="ml-auto flex items-center gap-item">
          {user ? (
            <ButtonLink to="/app" variant="soft">산정 시작으로</ButtonLink>
          ) : (
            <ButtonLink to="/login" variant="primary">로그인</ButtonLink>
          )}
        </div>
      </div>
    </header>
  );
}
